import React from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Slider from 'react-slick';
import { isMobile } from 'react-device-detect';

import { getColor } from './UICommon';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { FacilitatorCard } from './FacilitatorCard';
import { Facilitator } from '../steps/ProductInformationStep';

const FacilitatorBox = styled(Box)`
  padding: 8px 32px 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: 40px;
  column-gap: 55px;
  margin-bottom: 32px;
`;

const CarouselDiv = styled(Box)`
  padding-top: 8px;
  margin-bottom: 56px;
  & .slick-slide {
    height: auto;
  }
  & .slick-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
  }
  & .slick-dots {
    bottom: -20px;
    & li {
      font-size: 12px;
      margin: 0;
      height: 8px;
      width: 8px;
      margin-right: 8px;
      & button {
        padding: 0;
        height: 8px;
        width: 8px;
        margin-right: 8px;
      }
    }
    & button::before {
      color: #d9d9d9;
      opacity: 1;
      height: 8px;
      width: 8px;
      font-size: 8px;
    }
    & li.slick-active {
      & button::before {
        color: ${getColor('PURPLE_100')};
        height: 8px;
        width: 8px;
        font-size: 8px;
      }
    }
  }
`;

const BottomDiv = styled.div`
  margin: 0 32px;
  margin-bottom: 32px;
  border-bottom: 1px solid ${getColor('BLACK_10')};
`;

export enum CarouselType {
  Group = 'Group',
  Quote = 'Quote',
  Facilitator = 'Facilitator',
}

interface GroupsCarouselProps {
  facilitatorList: Facilitator[];
  isBottomBorder?: boolean;
}

export const FacilitatorSection = ({ facilitatorList, isBottomBorder }: GroupsCarouselProps) => {
  const MEMBERS_SLIDER_SETTINGS = {
    centerMode: true,
    infinite: false,
    speed: 1000,
    arrows: false,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          className: 'slider variable-width',
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <>
      {isMobile ? (
        <CarouselDiv>
          <Slider {...MEMBERS_SLIDER_SETTINGS}>
            {facilitatorList.map((facilitator: Facilitator) => (
              <FacilitatorCard key={facilitator.name} facilitator={facilitator} isCarousel={true} />
            ))}
          </Slider>
        </CarouselDiv>
      ) : (
        <FacilitatorBox>
          {facilitatorList.map((facilitator: Facilitator) => (
            <FacilitatorCard key={facilitator.name} facilitator={facilitator} isCarousel={false} />
          ))}
        </FacilitatorBox>
      )}

      {isBottomBorder ? <BottomDiv /> : null}
    </>
  );
};
